import { render, staticRenderFns } from "./DocumentsComplete.vue?vue&type=template&id=18853034&scoped=true&"
import script from "./DocumentsComplete.vue?vue&type=script&lang=js&"
export * from "./DocumentsComplete.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsComplete.vue?vue&type=style&index=0&id=18853034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18853034",
  null
  
)

export default component.exports